
const GlobalGoals = [
  {
    "goal": 1,
    "title": "End poverty in all its forms everywhere",
    "short": "No Poverty",
    "colorInfo": {
      "hex": "#e5243b",
      "rgb": [
        229,
        36,
        59
      ]
    }
  },
  {
    "goal": 2,
    "title": "End hunger, achieve food security and improved nutrition and promote sustainable agriculture",
    "short": "Zero Hunger",
    "colorInfo": {
      "hex": "#e5b735",
      "rgb": [
        229,
        183,
        53
      ]
    }
  },
  {
    "goal": 3,
    "title": "Ensure healthy lives and promote well-being for all at all ages",
    "short": "Good Health and Well-being",
    "colorInfo": {
      "hex": "#4c9f38",
      "rgb": [
        76,
        159,
        56
      ]
    }
  },
  {
    "goal": 4,
    "title": "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all",
    "short": "Quality Education",
    "colorInfo": {
      "hex": "#c5192d",
      "rgb": [
        197,
        25,
        45
      ]
    }
  },
  {
    "goal": 5,
    "title": "Achieve gender equality and empower all women and girls",
    "short": "Gender Equality",
    "colorInfo": {
      "hex": "#ff3a21",
      "rgb": [
        255,
        58,
        33
      ]
    }
  },
  {
    "goal": 6,
    "title": "Ensure availability and sustainable management of water and sanitation for all",
    "short": "Clean Water and Sanitation",
    "colorInfo": {
      "hex": "#26bde2",
      "rgb": [
        38,
        189,
        226
      ]
    }
  },
  {
    "goal": 7,
    "title": "Ensure access to affordable, reliable, sustainable and modern energy for all",
    "short": "Affordable and Clean Energy",
    "colorInfo": {
      "hex": "#fcc30b",
      "rgb": [
        252,
        195,
        11
      ]
    }
  },
  {
    "goal": 8,
    "title": "Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all",
    "short": "Decent Jobs and Economic Growth",
    "colorInfo": {
      "hex": "#a21942",
      "rgb": [
        162,
        25,
        66
      ]
    }
  },
  {
    "goal": 9,
    "title": "Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation",
    "short": "Industry, Innovation and Infrastructure",
    "colorInfo": {
      "hex": "#fd6925",
      "rgb": [
        253,
        105,
        37
      ]
    }
  },
  {
    "goal": 10,
    "title": "Reduce inequality within and among countries",
    "short": "Reduced Inequalities",
    "colorInfo": {
      "hex": "#dd1367",
      "rgb": [
        221,
        19,
        103
      ]
    }
  },
  {
    "goal": 11,
    "title": "Make cities and human settlements inclusive, safe, resilient and sustainable",
    "short": "Sustainable Cities and Communities",
    "colorInfo": {
      "hex": "#fd9d24",
      "rgb": [
        253,
        157,
        36
      ]
    }
  },
  {
    "goal": 12,
    "title": "Ensure sustainable consumption and production patterns",
    "short": "Responsible Consumption and Production",
    "colorInfo": {
      "hex": "#c9992d",
      "rgb": [
        201,
        153,
        45
      ]
    }
  },
  {
    "goal": 13,
    "title": "Take urgent action to combat climate change and its impacts.",
    "short": "Climate Action",
    "colorInfo": {
      "hex": "#3f7e44",
      "rgb": [
        63,
        126,
        68
      ]
    }
  },
  {
    "goal": 14,
    "title": "Conserve and sustainably use the oceans, seas and marine resources for sustainable development",
    "short": "Life Below Water",
    "colorInfo": {
      "hex": "#0a97d9",
      "rgb": [
        10,
        151,
        217
      ]
    }
  },
  {
    "goal": 15,
    "title": "Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss",
    "short": "Life on Land",
    "colorInfo": {
      "hex": "#56c02b",
      "rgb": [
        86,
        192,
        43
      ]
    }
  },
  {
    "goal": 16,
    "title": "Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels",
    "short": "Peace and Justice - Strong Institutions",
    "colorInfo": {
      "hex": "#00689d",
      "rgb": [
        0,
        104,
        157
      ]
    }
  },
  {
    "goal": 17,
    "title": "Strengthen the means of implementation and revitalize the global partnership for sustainable development",
    "short": "Partnerships for the Goals",
    "colorInfo": {
      "hex": "#19486a",
      "rgb": [
        25,
        72,
        106
      ]
    }
  }];

export default GlobalGoals;



// WEBPACK FOOTER //
// ./src/resources/GlobalGoals.js